import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

import { NotificationFacade, RelatedCardFacade } from '@ridango/components';
import { BaseComponent, CardTypes, RelatedCard } from '@ridango/core';

import { Observable } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'rwidget-register-seutulippu',
    templateUrl: './register-seutulippu.component.html'
})
export class RegisterSeutulippuComponent extends BaseComponent implements OnInit, OnDestroy {
    relatedCardsLoaded$: Observable<boolean> = this.relatedCardFacade.loaded$;
    relatedCards$: Observable<RelatedCard[]> = this.relatedCardFacade.typeTravelcardCards$;
    seutulippuLoading$: Observable<boolean> = this.relatedCardFacade.seutulippuLoading$;

    step = 1;
    startDate = new Date();
    seutulippuForm: FormGroup;
    walttiCards: RelatedCard[];
    selectedCard: RelatedCard;

    @Output() onSaveSuccess = new EventEmitter<any>();

    constructor(
        private relatedCardFacade: RelatedCardFacade,
        private notification: NotificationFacade,
        private translate: TranslateService
    ) {
        super();
    }

    ngOnInit() {
        this.seutulippuForm = new FormGroup({
            relatedCardId: new FormControl('', [Validators.required]),
            validity: new FormControl('', [Validators.required]),
            referenceNumber: new FormControl('', [Validators.pattern('[A-Z0-9]*'), Validators.required])
        });

        this.relatedCardFacade.fetchAllRelatedCards();

        this.relatedCards$.pipe(takeUntil(this.componentDestroyed$)).subscribe((cards: RelatedCard[]) => {
            if (cards) {
                this.walttiCards = cards.filter((card) => card.card_type === CardTypes.WALTTI_CARD);
            }
        });

        this.relatedCardFacade.seutulippuStatus$.pipe(takeUntil(this.componentDestroyed$)).subscribe((completed) => {
            if (completed) {
                this.relatedCardFacade.seutulippuError$.pipe(take(1)).subscribe((error) => {
                    window.scroll(0, 0);

                    if (error) {
                        this.handleError(error);
                    } else {
                        this.onSaveSuccess.emit();
                    }
                });
            }
        });
    }

    ngOnDestroy() {
        super.ngOnDestroy();
        this.relatedCardFacade.resetRelatedCards();
    }

    setRelatedCard(card: RelatedCard) {
        if (card) {
            this.selectedCard = card;
            this.seutulippuForm.controls['relatedCardId'].setValue(this.selectedCard.id);
            this.step = 2;
        }
    }

    setValidityDate(date: Date) {
        this.seutulippuForm.controls['validity'].setValue(date);
        this.step = this.step > 3 ? this.step : 3;
    }

    setPurchaseReference() {
        this.step = this.seutulippuForm.valid ? 4 : 3;
    }

    submitRequest() {
        if (this.seutulippuForm.valid) {
            this.relatedCardFacade.saveSeutulippu(this.seutulippuForm.value);
        }
    }

    handleError(e: any) {
        if (e.error.description) {
            this.notification.error(this.translate.instant(e.error.description));
        } else {
            this.notification.error(this.translate.instant(e.error));
        }
    }
}
